module.exports = __webpack_public_path__ + "static/media/image-icon.ae70cc18.svg";